<div class="ib-summary-bundle">
    <div class="ib-summary-bundle__header">
        <span class="ib-summary-bundle__icon icon-bundle-discount"></span>
        <h4 class="ib-heading ib-heading--type-4 ib-summary__section-title "> {{'BUNDLE_SUMMARY_TITLE'| translate}}</h4>
    </div>
    <ul class="ib-list-passengers">
        <li class="ib-list-passengers__item">
            <span class="ib-text ib-text--color-unfocused ib-text--bold ib-list-passengers">{{'BUNDLE_SUMMARY_ALL_TRIPS_AND_PASSENGERS'| translate}}</span>
            <div *ngFor="let item of bundles[0].items" class="ib-list-passengers__item-description ib-list-passengers__table">
                <span class="ib-text ib-text--color-unfocused ib-list-passengers__item-description">1 {{ item.description }}</span>
            </div>
        </li>
    </ul>

    <div class="ib-summary__subtotal ib-summary__subtotal--separator">
        <span class="ib-text ib-text--bold">{{'BUNDLE_SUMMARY_SUBTOTAL'| translate}}</span>
        <div class="ib-summary__total-price">
            <span class="ib-text ib-text--bold"> {{ bundles[0].totalItems }}</span>
        </div>
    </div>
</div>
